"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsolePage = void 0;
const react_1 = __importStar(require("react"));
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const doshx_controls_web_1 = require("doshx_controls_web");
const Sidebar_1 = require("../../components/Sidebar");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const constants_1 = require("../../constants/constants");
const routes_1 = require("../../constants/routes");
const main_1 = require("../../reducers/slices/main");
const home_1 = require("./pages/home");
const create_document_1 = require("./pages/document/create_document");
const my_account_1 = require("./pages/my_account");
const user_1 = require("../../reducers/slices/user/user");
const sign_out_thunk_1 = require("../../reducers/slices/user/thunks/sign_out_thunk");
const document_1 = require("./pages/document/document");
const my_document_1 = require("./pages/document/my_document");
const templates_1 = require("./pages/document/templates");
const local_storage_names_1 = require("../../constants/local_storage_names");
const logo_png_1 = __importDefault(require("../../assets/logo.png"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const access_auth_thunk_1 = require("../../reducers/slices/user/thunks/access_auth_thunk");
const unsigned_user_documents_thunk_1 = require("../../reducers/slices/document/thunks/unsigned_user_documents_thunk");
const signed_user_documents_thunk_1 = require("../../reducers/slices/document/thunks/signed_user_documents_thunk");
const unsigned_documents_1 = require("./pages/document/components/unsigned_documents");
const signed_documents_1 = require("./pages/document/components/signed_documents");
const locationHelper_1 = require("../../helpers/locationHelper");
const ConsolePage = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)(); //
    const location = (0, react_router_dom_1.useLocation)();
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const code = searchParams.get("code");
    const [isSideMenuOpen, setIsSideMenuOpen] = (0, react_1.useState)(false);
    const [isDrawerOpen, setIsDrawerOpen] = (0, react_1.useState)(false);
    const { entryTheme } = (0, react_redux_1.useSelector)((state) => state.entryState);
    const { pageTitle, showMenu } = (0, react_redux_1.useSelector)((state) => state.consoleState);
    const { user, token, isLoading, accessAuth } = (0, react_redux_1.useSelector)((state) => state.userState);
    const { unsignedUserDocumentsCount, signedUserDocumentsCount } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const returnTo = localStorage.getItem("return-to");
    (0, react_1.useEffect)(() => {
        const userLocalStorage = localStorage.getItem(local_storage_names_1.USER_LOCAL_STORAGE);
        if (userLocalStorage) {
            const ls = JSON.parse(userLocalStorage);
            dispatch((0, user_1.setUserToken)(ls.token));
            dispatch((0, user_1.setUser)(ls.user));
            if (code) {
                dispatch((0, access_auth_thunk_1.get_access_details_thunk)({ data: { code } })).then((response) => {
                    var _a;
                    if (!response.payload) {
                        // Auto sign-out for invalid/expired codes
                        dispatch((0, sign_out_thunk_1.sign_out_thunk)()).then(() => {
                            window.location.reload();
                        });
                    }
                    else if ((_a = response.payload.error) === null || _a === void 0 ? void 0 : _a.wrongUser) {
                        // Authentication conflict detected
                        const { intendedEmail, currentEmail } = response.payload.error;
                        dispatch((0, main_1.setMessageModal)({
                            title: "Authentication Conflict",
                            messages: [
                                `This document link is intended for ${intendedEmail || "another user"}.`,
                                `You are currently logged in as ${currentEmail}.`,
                                "",
                                "Please sign out to access this document with the correct credentials.",
                            ],
                            buttons: [
                                {
                                    label: "Sign Out",
                                    backgroundColor: "bg-error",
                                    textColor: "text-white",
                                    onClick: () => {
                                        dispatch((0, main_1.setMessageModal)(null));
                                        dispatch((0, sign_out_thunk_1.sign_out_thunk)()).then(() => {
                                            window.location.reload();
                                        });
                                    },
                                },
                                {
                                    label: "Stay Logged In",
                                    backgroundColor: "bg-secondary",
                                    textColor: "text-white",
                                    onClick: () => {
                                        dispatch((0, main_1.setMessageModal)(null));
                                        // Show access denied message
                                        dispatch((0, main_1.setMessageModal)({
                                            title: "Access Denied",
                                            messages: [
                                                "You cannot view this document without the correct authentication.",
                                                "",
                                                "Please sign out and use the link from your email to access the document.",
                                            ],
                                        }));
                                    },
                                },
                            ],
                        }));
                    }
                });
            }
            localStorage.removeItem("return-to");
            if (returnTo) {
                navigate(returnTo);
            }
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (user._id) {
            // Load documents
            dispatch((0, unsigned_user_documents_thunk_1.unsigned_user_documents_thunk)({ email: user.email }));
            dispatch((0, signed_user_documents_thunk_1.signed_user_documents_thunk)({ email: user.email }));
            // Request location permission after user is authenticated
            // MOBILE BYPASS: Mobile users already have location from accessAuth
            const requestLocation = () => __awaiter(void 0, void 0, void 0, function* () {
                // Skip location permission request for mobile users
                if ((accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.view_type) === constants_1.VIEW_TYPE.MOBILE) {
                    console.log("📱 Skipping location permission request for mobile user");
                    return;
                }
                const permissionGranted = yield (0, locationHelper_1.requestLocationPermission)();
                if (!permissionGranted) {
                    // Show blocking modal if location permission denied
                    dispatch((0, main_1.setMessageModal)({
                        title: "Location Permission Required",
                        messages: [
                            "SkySign requires your location to verify document signing.",
                            "Location sharing is mandatory for using this application.",
                            "",
                            "Please enable location permissions in your browser settings and refresh the page.",
                        ],
                        buttons: [
                            {
                                label: "Retry",
                                backgroundColor: "bg-primary",
                                textColor: "text-white",
                                onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                    dispatch((0, main_1.setMessageModal)(null));
                                    // Retry permission request
                                    const retryPermission = yield (0, locationHelper_1.requestLocationPermission)();
                                    if (!retryPermission) {
                                        // Still denied - log user out
                                        localStorage.removeItem("user_state");
                                        navigate(routes_1.WELCOME_ROUTE + routes_1.LOG_IN_ROUTE);
                                    }
                                }),
                            },
                            {
                                label: "Sign Out",
                                backgroundColor: "bg-secondary",
                                textColor: "text-white",
                                onClick: () => {
                                    dispatch((0, main_1.setMessageModal)(null));
                                    localStorage.removeItem("user_state");
                                    navigate(routes_1.WELCOME_ROUTE + routes_1.LOG_IN_ROUTE);
                                },
                            },
                        ],
                    }));
                }
            });
            // Request location permission
            setTimeout(() => requestLocation(), 2000);
        }
    }, [user._id, code]);
    return (react_1.default.createElement("div", { className: "h-full w-full flex flex-row bg-backgroundColor overflow-hidden" },
        showMenu && (react_1.default.createElement("div", { className: "hidden lg:block" },
            react_1.default.createElement(Sidebar_1.Sidebar, { logo: {
                    image: logo_png_1.default,
                    size: "medium",
                }, currentRoute: location.pathname, topMenuItems: [
                    { label: "Dashboard", icon: pro_light_svg_icons_1.faTable, route: `${routes_1.CONSOLE_ROUTE}${routes_1.DASHBOARD_ROUTE}` },
                    { label: "Create Document", icon: pro_light_svg_icons_1.faPlus, route: `${routes_1.CONSOLE_ROUTE}${routes_1.CREATE_DOCUMENT_ROUTE}` },
                    { label: "Documents", icon: pro_light_svg_icons_1.faEdit, route: `${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENTS_ROUTE}` },
                    { label: "Templates", icon: pro_light_svg_icons_1.faFile, route: `${routes_1.CONSOLE_ROUTE}${routes_1.TEMPLATES_ROUTE}` },
                    { label: "Account", icon: pro_light_svg_icons_1.faUser, route: `${routes_1.CONSOLE_ROUTE}${routes_1.MY_ACCOUNT_ROUTE}` },
                    {
                        label: "Inbox",
                        icon: pro_light_svg_icons_1.faInbox,
                        route: `${routes_1.CONSOLE_ROUTE}${routes_1.INBOX_ROUTE}`,
                        count: unsignedUserDocumentsCount > 0 ? unsignedUserDocumentsCount : null,
                    },
                    {
                        label: "Signed Documents",
                        icon: pro_light_svg_icons_1.faFile,
                        route: `${routes_1.CONSOLE_ROUTE}${routes_1.SIGNED_DOCUMENTS_ROUTE}`,
                    },
                ] }))),
        react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-2 sm:gap-4 h-full bg-backgroundColor w-full max-w-full" },
            !accessAuth || (accessAuth && (accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.view_type) === constants_1.VIEW_TYPE.WEBSITE) ? (react_1.default.createElement("div", { className: "flex flex-row items-center justify-between px-1 sm:px-4 pt-2 sm:pt-4 w-full" },
                react_1.default.createElement("div", { className: "flex flex-row items-center gap-2 sm:gap-4 min-w-0 flex-shrink" },
                    react_1.default.createElement("div", { className: "block lg:hidden flex-shrink-0" },
                        react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_solid_svg_icons_1.faBarsSort, backgroundColor: "bg-white", iconColor: "text-primary", borderColor: "border-none", onClick: () => setIsDrawerOpen(!isDrawerOpen) })),
                    react_1.default.createElement("div", { className: "flex gap-2 sm:gap-4 min-w-0" },
                        !showMenu && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faHome, className: "hidden lg:block font-bold flex-shrink-0 cursor-pointer", size: "2x", onClick: () => {
                                // Open sidebar drawer instead of navigating away
                                setIsDrawerOpen(true);
                            } })),
                        react_1.default.createElement("div", { className: "min-w-0 overflow-hidden" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: pageTitle, size: "xlarge", bold: true, textColor: "text-black", className: "truncate sm:text-xl text-base" })))),
                react_1.default.createElement("div", { className: "flex flex-row justify-center h-full gap-2 sm:gap-4 flex-shrink-0" },
                    react_1.default.createElement(doshx_controls_web_1.DividerControl, { orientation: "vertical", lineColor: "bg-borders" }),
                    react_1.default.createElement("div", { className: "block sm:hidden" },
                        react_1.default.createElement(doshx_controls_web_1.UserAccountDropdownControl, { label: "", imageBackgroundColor: "bg-white", options: [
                                {
                                    label: "My Account",
                                    onClick: () => {
                                        navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.MY_ACCOUNT_ROUTE}`);
                                    },
                                },
                                {
                                    label: "Log Out",
                                    onClick: () => {
                                        dispatch((0, sign_out_thunk_1.sign_out_thunk)()).then(() => {
                                            window.location.reload();
                                        });
                                    },
                                },
                            ].filter(Boolean) })),
                    react_1.default.createElement("div", { className: "hidden sm:block" },
                        react_1.default.createElement(doshx_controls_web_1.UserAccountDropdownControl, { label: `${user.name} ${user.surname}`, imageBackgroundColor: "bg-white", options: [
                                {
                                    label: "My Account",
                                    onClick: () => {
                                        navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.MY_ACCOUNT_ROUTE}`);
                                    },
                                },
                                {
                                    label: "Log Out",
                                    onClick: () => {
                                        dispatch((0, sign_out_thunk_1.sign_out_thunk)()).then(() => {
                                            window.location.reload();
                                        });
                                    },
                                },
                            ].filter(Boolean) }))))) : (""),
            react_1.default.createElement("div", { className: "px-0 sm:px-4 flex-1 overflow-y-auto bg-backgroundColor", id: "main-div", onScroll: (e) => {
                    var _a;
                    dispatch((0, main_1.setMainDivScrolled)((_a = e.target) === null || _a === void 0 ? void 0 : _a.scrollTop));
                } },
                react_1.default.createElement(react_router_dom_1.Routes, null,
                    react_1.default.createElement(react_router_dom_1.Route, { index: true, element: react_1.default.createElement(react_router_dom_1.Navigate, { to: `${routes_1.CONSOLE_ROUTE}${routes_1.DASHBOARD_ROUTE}` }) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: routes_1.DASHBOARD_ROUTE, element: react_1.default.createElement(home_1.HomePage, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: `${routes_1.CREATE_DOCUMENT_ROUTE}`, element: react_1.default.createElement(create_document_1.CreateDocumentPage, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: `${routes_1.DOCUMENT_ROUTE}/:document_id/:type?`, element: react_1.default.createElement(document_1.DocumentPage, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: `${routes_1.DOCUMENTS_ROUTE}`, element: react_1.default.createElement(my_document_1.MyDocumentsPage, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: `${routes_1.DOCUMENT_SHARE_ROUTE}/:document_id/:share-hash`, element: react_1.default.createElement(document_1.DocumentPage, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: routes_1.MY_ACCOUNT_ROUTE, element: react_1.default.createElement(my_account_1.MyAccountPage, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: `${routes_1.TEMPLATES_ROUTE}`, element: react_1.default.createElement(templates_1.TemplatesPage, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: `${routes_1.INBOX_ROUTE}`, element: react_1.default.createElement(unsigned_documents_1.UnsignedDocuments, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: `${routes_1.SIGNED_DOCUMENTS_ROUTE}`, element: react_1.default.createElement(signed_documents_1.SignedDocuments, null) })))),
        react_1.default.createElement(react_1.default.Fragment, null,
            isDrawerOpen && (react_1.default.createElement("div", { className: `fixed inset-0 bg-black bg-opacity-50 z-40 ${showMenu ? "lg:hidden" : ""}`, onClick: () => setIsDrawerOpen(false) })),
            react_1.default.createElement("div", { className: `fixed top-0 left-0 h-full w-64 bg-white z-50 transform transition-transform duration-300 ease-in-out ${showMenu ? "lg:hidden" : ""} ${isDrawerOpen ? "translate-x-0" : "-translate-x-full"}` },
                react_1.default.createElement(Sidebar_1.Sidebar, { logo: {
                        image: logo_png_1.default,
                        size: "medium",
                    }, currentRoute: location.pathname, topMenuItems: [
                        { label: "Dashboard", icon: pro_light_svg_icons_1.faTable, route: `${routes_1.CONSOLE_ROUTE}${routes_1.DASHBOARD_ROUTE}` },
                        { label: "Create Document", icon: pro_light_svg_icons_1.faPlus, route: `${routes_1.CONSOLE_ROUTE}${routes_1.CREATE_DOCUMENT_ROUTE}` },
                        { label: "Documents", icon: pro_light_svg_icons_1.faEdit, route: `${routes_1.CONSOLE_ROUTE}${routes_1.DOCUMENTS_ROUTE}` },
                        { label: "Templates", icon: pro_light_svg_icons_1.faFile, route: `${routes_1.CONSOLE_ROUTE}${routes_1.TEMPLATES_ROUTE}` },
                        { label: "Account", icon: pro_light_svg_icons_1.faUser, route: `${routes_1.CONSOLE_ROUTE}${routes_1.MY_ACCOUNT_ROUTE}` },
                        {
                            label: "Inbox",
                            icon: pro_light_svg_icons_1.faInbox,
                            route: `${routes_1.CONSOLE_ROUTE}${routes_1.INBOX_ROUTE}`,
                            count: unsignedUserDocumentsCount > 0 ? unsignedUserDocumentsCount : null,
                        },
                        {
                            label: "Signed Documents",
                            icon: pro_light_svg_icons_1.faFile,
                            route: `${routes_1.CONSOLE_ROUTE}${routes_1.SIGNED_DOCUMENTS_ROUTE}`,
                        },
                    ], onMenuItemClick: (item) => {
                        navigate(item.route);
                        setIsDrawerOpen(false);
                    } })))));
};
exports.ConsolePage = ConsolePage;
